import logoFallback from "../assets/logo.svg";
import { Button, useTheme } from "senzo-design-system";

type UnauthorizedPageProps = {
  onLogout: () => void;
};

export function UnauthorizedPage({ onLogout }: Readonly<UnauthorizedPageProps>) {
  const { logoUrl } = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "var(--color-background)",
        padding: "24px",
      }}
    >
      <div
        style={{
          background: "var(--color-card)",
          border: "1px solid var(--color-border)",
          borderRadius: "16px",
          padding: "48px 40px",
          maxWidth: "440px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
          boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
        }}
      >
        {/* Logo */}
        <img
          src={logoUrl ?? logoFallback}
          alt="Senzo"
          style={{ height: "36px", objectFit: "contain" }}
        />


        {/* Testo */}
        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "8px" }}>
          <h2
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: 700,
              color: "var(--color-foreground)",
            }}
          >
            Accesso non autorizzato
          </h2>
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              color: "var(--text-secondary)",
              lineHeight: 1.6,
            }}
          >
            Questa applicazione è riservata!<br/>
            Il tuo account non dispone dei permessi necessari per accedere.
          </p>
        </div>

        <div
          style={{
            width: "100%",
            height: "1px",
            background: "var(--color-border)",
          }}
        />
        <Button
          type="button"
          variant="danger"
          onClick={onLogout}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "var(--color-background)";
            e.currentTarget.style.borderColor = "var(--border-strong)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "var(--color-card)";
            e.currentTarget.style.borderColor = "var(--color-border)";
          }}
        >
          Esci dall'account
        </Button>
      </div>

      <p
        style={{
          marginTop: "24px",
          fontSize: "12px",
          color: "var(--text-secondary)",
        }}
      >
        Se ritieni di dover avere accesso, contatta il tuo amministratore.
      </p>
    </div>
  );
}